export enum ReportDataModel {
  AOP_FORM = 1,
  JSON_FORM = 2
}
